import { getAudienceUseCase } from '@/data/audienceUseCases';

const SIZE_MAP = {
  sm: { box: 'h-8 w-8', icon: 'h-4 w-4' },
  md: { box: 'h-10 w-10', icon: 'h-5 w-5' },
  lg: { box: 'h-16 w-16 sm:h-20 sm:w-20', icon: 'h-8 w-8 sm:h-10 sm:w-10' },
};

/**
 * Shared audience use-case icon badge (landing, CPP, dashboard, etc.).
 */
export function AudienceUseCaseIcon({
  useCaseId,
  size = 'md',
  className = '',
  accentOverride,
  showGlow = false,
}) {
  const useCase = getAudienceUseCase(useCaseId);
  const { Icon, accent } = useCase;
  const color = accentOverride || accent;
  const dims = SIZE_MAP[size] || SIZE_MAP.md;

  return (
    <div
      className={`flex shrink-0 items-center justify-center border border-[var(--glass-border)] bg-[var(--glass-bg)] ${dims.box} ${className}`}
      style={showGlow ? { boxShadow: `0 0 32px ${color}33` } : undefined}
      aria-hidden
    >
      <Icon className={dims.icon} style={{ color }} strokeWidth={1.5} />
    </div>
  );
}
